export default __webpack_public_path__ + "static/base-lite-2-b4425608cd9d324c07923d1aba0e9d31.jpg";